import React from 'react'
import { Box, Button, CircularProgress, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import { useIsMobileScreen } from '~/hooks'

export type ContentProps = {
  title: string,
  loading?: boolean,
  buttonLabel?: string,
  removeButton?: boolean,
  shouldContinue?: boolean,
  description: string | JSX.Element,
  onContinueButtonPress?: () => void
}

const useStyles = makeStyles({
  container: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    [mutualTheme.breakpoints.down('md')]: {
      padding: mutualTheme.spacing(1)
    }
  },
  title: {
    fontWeight: 700,
    marginBottom: mutualTheme.spacing(2),
    color: mutualTheme.palette.mutualBlue.main
  },
  description: {
    marginBottom: mutualTheme.spacing(5),
    [mutualTheme.breakpoints.down('lg')]: {
      marginBottom: mutualTheme.spacing(3)
    }
  },
  nextButton: {
    borderRadius: 5,
    alignSelf: 'flex-end',
    textTransform: 'none',
    marginTop: mutualTheme.spacing(5)
  },
  buttonText: {
    fontWeight: 700
  },
  childrenContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: mutualTheme.spacing(1),
    [mutualTheme.breakpoints.down('lg')]: {
      width: '100%'
    }
  }
})

export const Content: React.FC<ContentProps> = (props) => {
  const { title, description, children, onContinueButtonPress, removeButton, shouldContinue, buttonLabel, loading } = props
  const classes = useStyles()
  const isMobile = useIsMobileScreen()

  return (
    <Box className={classes.container}>
      <Typography variant='h1' className={classes.title}>
        {title}
      </Typography>
      <Typography variant={isMobile ? 'body2' : 'body1'} className={classes.description}>
        {description}
      </Typography>
      <Box className={classes.childrenContainer}>
        {children}
        {!removeButton && (
          <Button
            color='primary'
            disableElevation
            variant='contained'
            className={classes.nextButton}
            onClick={onContinueButtonPress}
            type='submit'
            disabled={!shouldContinue}
            startIcon={loading ? <CircularProgress color='inherit' size={20} /> : null}
            sx={{
              borderRadius: 5,
              alignSelf: 'flex-end',
              textTransform: 'none',
              justifySelf: 'flex-end',
              height: 48,
              marginTop: 5,
              marginBottom: 5
            }}
          >
            <Typography sx={{ fontWeight: 700 }}>
              {buttonLabel || 'Próximo'}
            </Typography>
          </Button>
        )}
      </Box>
    </Box>
  )
}
